export const checkIsCaptain = (rolename: string) => {
  return rolename?.toLowerCase().includes("captain");
};
